/**
 * OnboardingRedirect
 *
 * Checks if authenticated user has completed onboarding.
 * Redirects to onboarding flow if not completed.
 * Should be placed in the main layout to run on page loads.
 *
 * NOTE: Redirect is currently disabled. The onboarding page is only
 * accessible directly via /onboarding for logged-in users.
 * Set ENABLE_ONBOARDING_REDIRECT to true to re-enable automatic redirects.
 */

// Feature flag to enable/disable onboarding redirect
const ENABLE_ONBOARDING_REDIRECT = false;

export function OnboardingRedirect() {
  // Redirect functionality is disabled for now
  // When enabled, this component will redirect users who haven't completed
  // onboarding to the /onboarding page
  if (!ENABLE_ONBOARDING_REDIRECT) {
    return null;
  }

  // The redirect logic below is preserved but not executed
  // To re-enable, set ENABLE_ONBOARDING_REDIRECT to true
  return null;
}
